import { changeStyle, themes } from '@common/assets/style/theme/model';
import { assertCurProduct } from '@common/utils/productInfo';
import getIsNew from '@common/stores/utils/getIsNew';

export default function () {}
